import React, { useState, useEffect } from 'react';

const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.shortflix&pcampaignid=web_share';
const APP_STORE_URL  = 'https://apps.apple.com/in/app/shortflix/id1448385291';
const DISMISS_KEY    = 'sf_app_banner_dismissed';
const DISMISS_DAYS   = 3;

function detectPlatform() {
  const ua = navigator.userAgent || '';
  if (/iPhone|iPad|iPod/i.test(ua)) return 'ios';
  if (/Android/i.test(ua)) return 'android';
  return 'desktop';
}

// Shown to everyone — mobile gets a Play Store / App Store install prompt,
// desktop gets a "this is better in the app" nudge linking to both stores.
export default function AppInstallBanner() {
  const [visible,  setVisible]  = useState(false);
  const [platform, setPlatform] = useState('desktop');

  useEffect(() => {
    // Don't show again if dismissed within the last few days
    const dismissed = localStorage.getItem(DISMISS_KEY);
    if (dismissed && Date.now() - parseInt(dismissed, 10) < DISMISS_DAYS * 24 * 60 * 60 * 1000) return;

    setPlatform(detectPlatform());
    setVisible(true);
  }, []);

  // Push page content down while the banner is showing — done via a body
  // class (not CSS :has()) for broader browser support, including Safari
  // versions that predate :has().
  useEffect(() => {
    document.body.classList.toggle('sf-banner-open', visible);
    return () => document.body.classList.remove('sf-banner-open');
  }, [visible]);

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, Date.now().toString());
    setVisible(false);
  };

  const install = () => {
    if (platform === 'ios') window.open(APP_STORE_URL, '_blank', 'noopener,noreferrer');
    else if (platform === 'android') window.open(PLAY_STORE_URL, '_blank', 'noopener,noreferrer');
    dismiss();
  };

  if (!visible) return null;

  const isMobile = platform === 'ios' || platform === 'android';

  return (
    <div className={`app-install-banner${isMobile ? ' app-install-banner--mobile' : ' app-install-banner--desktop'}`}>
      {/* Close */}
      <button onClick={dismiss} aria-label="Dismiss" className="app-install-close">✕</button>

      {/* App icon */}
      <img src="/assets/brand/logo.png" alt="Shortflix" className="app-install-icon" />

      {/* Text */}
      <div className="app-install-text">
        <div className="app-install-title">
          {isMobile ? 'Get the Shortflix App' : 'Enjoy Shortflix the way it was meant to be watched'}
        </div>
        <div className="app-install-sub">
          {isMobile
            ? 'Smoother playback • Faster browsing • Built for your phone'
            : 'Install the app on your phone for the full Shortflix experience'}
        </div>
      </div>

      {/* Action(s) */}
      {isMobile ? (
        <button onClick={install} className="app-install-btn">
          {platform === 'ios' ? 'App Store' : 'Install'}
        </button>
      ) : (
        <div className="app-install-store-links">
          <a href={PLAY_STORE_URL} target="_blank" rel="noopener noreferrer" className="app-install-store-link" onClick={dismiss}>
            <img src="/assets/store-badges/playstore.png" alt="Get it on Google Play" />
          </a>
          <a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer" className="app-install-store-link" onClick={dismiss}>
            <img src="/assets/store-badges/appstore.png" alt="Download on the App Store" />
          </a>
        </div>
      )}
    </div>
  );
}
